exports.computeSelectionOpacity = canvasStateItems => {
    const opacities = canvasStateItems
        .map(item => (
            item.get('opacity') ||
            item.getIn(['assignedStyles', 'shape', 'opacity'])
        ));
    return opacities.size === 1 ? (opacities.first() || 1) : 1;
};
